import React, { FC } from 'react'

import type { SelectFieldProps } from '@/types'
import { Dropdown } from '@/atoms'
import { BaseField } from '@/molecules/base-field'

export const SelectField: FC<SelectFieldProps> = ({
  error,
  placeholder,
  label,
  caption,
  name,
  value,
  multiple,
  onChange,
  onBlur,
  disabled,
  fullWidth = false,
  loadingMessage = 'Cargando...',
  noOptionsMessage = 'No hay opciones...',
  options = [],
  isClearable = true,
  isSearchable = true,
  isLoading = false,
  containerProps = {},
  labelProps = {},
  captionProps = {},
  dropdownProps = {},
}) => {
  return (
    <BaseField
      label={label}
      caption={caption}
      error={error}
      disabled={disabled}
      containerProps={containerProps}
      labelProps={labelProps}
      captionProps={captionProps}
      fullWidth={fullWidth}
    >
      <Dropdown
        options={options}
        placeholder={placeholder}
        name={name}
        value={value}
        isMulti={multiple}
        onChange={onChange}
        onBlur={onBlur}
        isDisabled={disabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isLoading={isLoading}
        loadingMessage={() => loadingMessage}
        noOptionsMessage={() => noOptionsMessage}
        {...dropdownProps}
      />
    </BaseField>
  )
}
